export const SET_CONTROL = 'REGISTRATION_CONTROL/SET_CONTROL'
export const SET_CONTROLS = 'REGISTRATION_CONTROL/SET_CONTROLS'
export const SET_ITEMS = 'REGISTRATION_CONTROL/SET_ITEMS'
export const SET_ITEM = 'REGISTRATION_CONTROL/SET_ITEM'
export const SET_GROUPS = 'REGISTRATION_CONTROL/SET_GROUPS'
export const SET_GROUP = 'REGISTRATION_CONTROL/SET_GROUP'
